export default {
  salvar: "Salvar",
  editar: "Editar",
  cancelar: "Cancelar",
  success: "Alterações salvas com sucesso!",
  fail: "Falha ao tentar cadastrar.",
  incomplete_component: "Não foi possível salvar, existe algum componente que não está preenchido.",
};
